export enum FlatOrderBy {
  PRICE_ASC = 'price asc',
  PRICE_DESC = 'price desc',
}
